(() => {
  const init = () => {
    document.querySelectorAll('[data-pdp-re-reasons]:not([data-pdp-re-reasons-ready])').forEach((section) => {
      section.setAttribute('data-pdp-re-reasons-ready', 'true');

      const track = section.querySelector('[data-reasons-track]');
      const slides = Array.from(section.querySelectorAll('[data-reasons-slide]'));
      const prev = section.querySelector('[data-reasons-prev]');
      const next = section.querySelector('[data-reasons-next]');
      const dots = Array.from(section.querySelectorAll('[data-reasons-dot]'));
      if (!track || slides.length < 2) return;

      let current = 0;
      let ticking = false;

      const step = () => {
        const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        return slides[0].getBoundingClientRect().width + gap;
      };

      const render = () => {
        dots.forEach((dot, i) => {
          dot.classList.toggle('is-active', i === current);
          dot.setAttribute('aria-current', i === current ? 'true' : 'false');
        });
        if (prev) prev.disabled = current === 0;
        if (next) next.disabled = current === slides.length - 1;
      };

      const goTo = (index) => {
        current = Math.max(0, Math.min(index, slides.length - 1));
        track.scrollTo({ left: current * step(), behavior: 'smooth' });
        render();
      };

      const onScroll = () => {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(() => {
          ticking = false;
          const width = step();
          if (!width) return;
          const index = Math.round(track.scrollLeft / width);
          if (index !== current) {
            current = Math.max(0, Math.min(index, slides.length - 1));
            render();
          }
        });
      };

      if (prev) prev.addEventListener('click', () => goTo(current - 1));
      if (next) next.addEventListener('click', () => goTo(current + 1));
      dots.forEach((dot) => dot.addEventListener('click', () => goTo(Number(dot.dataset.reasonsDot))));
      track.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', () => {
        track.scrollLeft = current * step();
      });

      render();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();